import { Injectable, ElementRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class WtFocusService {
  private _controls: Map<AbstractControl, ElementRef> = new Map();

  public registerFocusableFormControl(formControl: AbstractControl, el: ElementRef): void {
    this._controls.set(formControl, el);
  }

  public deregisterFocusableFormControl(formControl: AbstractControl): void {
    this._controls.delete(formControl);
  }

  public focusFormControl(formControl: AbstractControl): void {
    if (this._controls.get(formControl)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this._controls.get(formControl)?.nativeElement.focus();
    }
  }
}
